// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable no-param-reassign */
import Money from '@square/dashboard-money/models/money';

// This is for legacy API calls which use cents. New API calls should use amount,
// as described in https://git.sqcorp.co/projects/SQ/repos/docs/browse/api/money.md
// and https://git.sqcorp.co/square/protos/blob/master/squareup/common/currency.proto

/**
 * TODO(johnweathers): the git.squarup.com link is dead. Need to replace with live link to similar info
 */
export default {
  deserialize(hash) {
    if (!hash) {
      return null;
    }
    if (hash._currencyCode) {
      hash.currency_code = hash._currencyCode;
    }
    if (hash._amount) {
      hash.cents = hash._amount;
    }
    return Money.create({
      amount: hash.cents,
      currencyCode: hash.currency_code
    });
  },
  serialize(money) {
    if (!money || !money.isDefined()) {
      return null;
    }
    return {
      cents: money.amount,
      currency_code: money.currencyCode
    };
  }
};